import { createForm } from '../../../factories'

export default createForm(['name', 'enableBioreq'])



// WEBPACK FOOTER //
// ./src/store/modules/tenants/forms/store.js